/* Component Dependencies */
var hotelLegalInformationTemplate = require('templates/hotelLegalInformation.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'hotelLegalInformation',
  template: {
    'hotelLegalInformation': hotelLegalInformationTemplate
  }
});
